import { randomID } from './S';
import axios from 'axios';  
import { message } from 'antd';
import { globalStore } from '../models/globalStore';

// 定义泛型 Request 接口
export interface Request<T> {
    requestId: string;
    traceId: string;
    token: string; 
    parameter: T;
}

export interface Response<T>{
    success: boolean;
    result: T;
    costTime: number;
    errorCode: string,
    errorMessages: string
}

const navigateWrapper = {
    nav: null as null | ((path: string) => void)
};
 
// 判断是否为日期字符串
const isDateString = (value: any): boolean => {
    return typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value);
};

// 将对象中的所有日期字符串转换为 Date 对象
const convertDates = (obj: any): any => {
    if (Array.isArray(obj)) {
        return obj.map(convertDates);
    } else if (obj && typeof obj === 'object') {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (isDateString(obj[key])) {
                    obj[key] = new Date(obj[key]);
                } else if (typeof obj[key] === 'object') {
                    obj[key] = convertDates(obj[key]);
                }
            }
        }
    }
    return obj;
};

// 将 Date 对象转换为字符串，格式为 "YYYY-MM-DD HH:MM:SS"
const formatDateToString = (date: Date): string => {
    if(!date) return "未知";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// 遍历对象，将所有 Date 类型转换为字符串
const convertDatesToString = (obj: any): any => {
    if (Array.isArray(obj)) {
        return obj.map(convertDatesToString);
    } else if (obj && typeof obj === 'object') {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] instanceof Date) {
                    obj[key] = formatDateToString(obj[key]);
                } else if (typeof obj[key] === 'object') {
                    obj[key] = convertDatesToString(obj[key]);
                }
            }
        }
    }
    return obj;
};

// 通用的请求方法
export const post = async <T, R>(url: string, inputParameter: T): Promise<R|string> => {
    let status = false;
    let result: R | null = null;
    let error: any = null;
    let errorCode: string = "";

    try {    
        const traceId: string = randomID(); 
        const token: string | null = localStorage.getItem('token');
        console.log("URL is " + url);
        console.log("Trace id is " + traceId);
        console.log("Token is " + token);
        inputParameter = convertDatesToString(inputParameter);
        const requestData: Request<T> = {
            requestId: traceId,
            traceId: traceId,
            token: token as string, 
            parameter: inputParameter
        }; 

        const response = await axios.post<Response<R>>(`${API_DOMAIN}${url}`, requestData);
        status = response.data.success;

        if (status) {
            // 转换所有日期字段
            result = convertDates(response.data.result);
        } else {
            errorCode = response.data.errorCode;
            if (errorCode === '0000111') {
                globalStore.forceLogoutToLogin();
            }
            if (errorCode === '0000007') {
                // 用户不存在
                message.warning("该用户不存在！请联系管理员！");
            }
            error = response.data.errorMessages; 
            
        }
    } catch (e) {
        error = e;
        throw new Error(errorCode);
    }

    if (status) {
        return result as R;
    } else {
        return errorCode as string;
    }
};
 

export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;

console.log('API URL:', API_DOMAIN);